import { safeHtml } from "./sanitizeHtml";

/**
 * Renders rich-text (Jodit editor) HTML safely styled.
 * Use this anywhere editor content is shown so tags never appear as raw text.
 * The `.rich-content` styles (lists, headings, links, images) live in index.css.
 *
 * The HTML is run through the shared allowlist first — it reaches us from the
 * creator's editor, and members' sessions live in localStorage where any script
 * that slipped through could read them.
 */
export default function RichText({ html, className = "" }) {
  if (!html) return null;
  return (
    <div
      className={`rich-content ${className}`.trim()}
      dangerouslySetInnerHTML={safeHtml(html)}
    />
  );
}
